// Registers the Figma template registries on window.wellFunnelConfig; the SDK preview merges them over its built-ins.
// Must land before the SDK Object.freeze()s that config. It only freezes inside the lazy-loaded preview chunks,
// so importing this from src/index.tsx is early enough — if an eager @welltech/wellfunnel import ever enters the boot
// graph, move this merge into the index.html <head> module instead.
import { customOnboardingTemplates, customPaymentTemplates } from '@welltech/welllabs-templates';

declare global {
    interface Window {
        wellFunnelConfig?: Record<string, unknown>;
    }
}

window.wellFunnelConfig = {
    ...window.wellFunnelConfig,
    customOnboardingTemplates,
    customPaymentTemplates,
};
